export const setQueryParams = (
  key: string,
  value: string,
  deleteState?: boolean
) => {
  const url = new URL(window.location.toString());
  url.searchParams.set(key, value);
  window.history.replaceState(deleteState ? null : history.state, "", url);
};
export const deleteQueryParams = (key: string, deleteState?: boolean) => {
  const url = new URL(window.location.toString());
  url.searchParams.delete(key);
  window.history.replaceState(deleteState ? null : history.state, "", url);
};

export const getQueryParam = (key: string) => {
  const sp = new URLSearchParams(window.location.search);
  return sp.get(key);
};
